// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/container/v1/snapshot_compatibility.proto (package chalk.container.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/container/v1/snapshot_compatibility.proto.
 */
export const file_chalk_container_v1_snapshot_compatibility: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Matching keys use the canonical collection/encoding rules of schema_version.
 * Zero/unknown versions, empty required keys and absent metadata are unclassified,
 * not wildcards. Equality is the initial policy; identities are not matching keys.
 *
 * @generated from message chalk.container.v1.SnapshotCompatibilityRequirements
 */
export type SnapshotCompatibilityRequirements = Message<"chalk.container.v1.SnapshotCompatibilityRequirements"> & {
  /**
   * @generated from field: uint32 schema_version = 1;
   */
  schemaVersion: number;

  /**
   * @generated from field: string cpu_class = 2;
   */
  cpuClass: string;

  /**
   * @generated from field: string runtime_class = 3;
   */
  runtimeClass: string;

  /**
   * @generated from field: chalk.container.v1.SnapshotMachineType machine_type = 4;
   */
  machineType?: SnapshotMachineType;

  /**
   * Explicit NONE distinguishes CPU-only snapshots from legacy/unknown state.
   *
   * @generated from field: chalk.container.v1.SnapshotGpuBackend gpu_backend = 5;
   */
  gpuBackend: SnapshotGpuBackend;

  /**
   * Required for NVIDIA_CUDA, absent for NONE. Includes every assigned device.
   *
   * @generated from field: chalk.container.v1.SnapshotGpuRequirements gpu = 6;
   */
  gpu?: SnapshotGpuRequirements;
};

/**
 * Describes the message chalk.container.v1.SnapshotCompatibilityRequirements.
 * Use `create(SnapshotCompatibilityRequirementsSchema)` to create a new message.
 */
export const SnapshotCompatibilityRequirementsSchema: GenMessage<SnapshotCompatibilityRequirements> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 0);

/**
 * Provider-qualified machine SKU, or an authoritative configured external-host
 * class. Region, pool and physical VM identity are separate placement inputs.
 *
 * @generated from message chalk.container.v1.SnapshotMachineType
 */
export type SnapshotMachineType = Message<"chalk.container.v1.SnapshotMachineType"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotMachineType.
 * Use `create(SnapshotMachineTypeSchema)` to create a new message.
 */
export const SnapshotMachineTypeSchema: GenMessage<SnapshotMachineType> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 1);

/**
 * @generated from message chalk.container.v1.SnapshotGpuRequirements
 */
export type SnapshotGpuRequirements = Message<"chalk.container.v1.SnapshotGpuRequirements"> & {
  /**
   * @generated from field: uint32 backend_version = 1;
   */
  backendVersion: number;

  /**
   * @generated from field: string stack_class = 2;
   */
  stackClass: string;

  /**
   * Logical ordinals are unique and contiguous from zero. Preserve their order
   * when binding replacement hardware; physical UUIDs/minors may differ.
   *
   * @generated from field: repeated chalk.container.v1.SnapshotGpuDeviceRequirement devices = 3;
   */
  devices: SnapshotGpuDeviceRequirement[];

  /**
   * @generated from field: repeated chalk.container.v1.SnapshotGpuPeerLink peer_links = 4;
   */
  peerLinks: SnapshotGpuPeerLink[];
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuRequirements.
 * Use `create(SnapshotGpuRequirementsSchema)` to create a new message.
 */
export const SnapshotGpuRequirementsSchema: GenMessage<SnapshotGpuRequirements> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 2);

/**
 * @generated from message chalk.container.v1.SnapshotGpuDeviceRequirement
 */
export type SnapshotGpuDeviceRequirement = Message<"chalk.container.v1.SnapshotGpuDeviceRequirement"> & {
  /**
   * @generated from field: uint32 logical_ordinal = 1;
   */
  logicalOrdinal: number;

  /**
   * @generated from field: string hardware_class = 2;
   */
  hardwareClass: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuDeviceRequirement.
 * Use `create(SnapshotGpuDeviceRequirementSchema)` to create a new message.
 */
export const SnapshotGpuDeviceRequirementSchema: GenMessage<SnapshotGpuDeviceRequirement> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 3);

/**
 * Directed peer requirements between logical ordinals. Link classes describe
 * validated interconnect properties, excluding physical bus addresses/UUIDs.
 *
 * @generated from message chalk.container.v1.SnapshotGpuPeerLink
 */
export type SnapshotGpuPeerLink = Message<"chalk.container.v1.SnapshotGpuPeerLink"> & {
  /**
   * @generated from field: uint32 source_ordinal = 1;
   */
  sourceOrdinal: number;

  /**
   * @generated from field: uint32 destination_ordinal = 2;
   */
  destinationOrdinal: number;

  /**
   * @generated from field: bool cuda_peer_access = 3;
   */
  cudaPeerAccess: boolean;

  /**
   * @generated from field: string interconnect_class = 4;
   */
  interconnectClass: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuPeerLink.
 * Use `create(SnapshotGpuPeerLinkSchema)` to create a new message.
 */
export const SnapshotGpuPeerLinkSchema: GenMessage<SnapshotGpuPeerLink> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 4);

/**
 * System-generated metadata bound to the checkpoint generation.
 * Callers must not supply or weaken requirements.
 *
 * @generated from message chalk.container.v1.SnapshotCompatibility
 */
export type SnapshotCompatibility = Message<"chalk.container.v1.SnapshotCompatibility"> & {
  /**
   * @generated from field: chalk.container.v1.SnapshotCompatibilityRequirements requirements = 1;
   */
  requirements?: SnapshotCompatibilityRequirements;

  /**
   * @generated from field: chalk.container.v1.SnapshotGpuStackProfile gpu_stack = 4;
   */
  gpuStack?: SnapshotGpuStackProfile;

  /**
   * @generated from field: repeated chalk.container.v1.SnapshotGpuDevice gpu_devices = 5;
   */
  gpuDevices: SnapshotGpuDevice[];

  /**
   * @generated from field: chalk.container.v1.SnapshotCaptureSource source = 6;
   */
  source?: SnapshotCaptureSource;
};

/**
 * Describes the message chalk.container.v1.SnapshotCompatibility.
 * Use `create(SnapshotCompatibilitySchema)` to create a new message.
 */
export const SnapshotCompatibilitySchema: GenMessage<SnapshotCompatibility> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 5);

/**
 * @generated from message chalk.container.v1.SnapshotCaptureSource
 */
export type SnapshotCaptureSource = Message<"chalk.container.v1.SnapshotCaptureSource"> & {
  /**
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * @generated from field: string machine_id = 2;
   */
  machineId: string;

  /**
   * @generated from field: string boot_id = 3;
   */
  bootId: string;

  /**
   * @generated from field: string inventory_generation = 4;
   */
  inventoryGeneration: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotCaptureSource.
 * Use `create(SnapshotCaptureSourceSchema)` to create a new message.
 */
export const SnapshotCaptureSourceSchema: GenMessage<SnapshotCaptureSource> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 6);

/**
 * Host capabilities describe hardware, not current free/reserved capacity.
 * Absent reports on targeted heartbeats must not erase the last full inventory.
 *
 * @generated from message chalk.container.v1.SnapshotHostCapabilities
 */
export type SnapshotHostCapabilities = Message<"chalk.container.v1.SnapshotHostCapabilities"> & {
  /**
   * @generated from field: repeated uint32 supported_schema_versions = 1;
   */
  supportedSchemaVersions: number[];

  /**
   * @generated from field: chalk.container.v1.SnapshotMachineType machine_type = 2;
   */
  machineType?: SnapshotMachineType;

  /**
   * @generated from field: string cpu_class = 3;
   */
  cpuClass: string;

  /**
   * @generated from field: string runtime_class = 4;
   */
  runtimeClass: string;

  /**
   * @generated from field: chalk.container.v1.SnapshotGpuStackProfile gpu_stack = 5;
   */
  gpuStack?: SnapshotGpuStackProfile;

  /**
   * @generated from field: repeated chalk.container.v1.SnapshotGpuDevice gpu_devices = 6;
   */
  gpuDevices: SnapshotGpuDevice[];

  /**
   * @generated from field: repeated chalk.container.v1.SnapshotGpuPeerLink peer_links = 7;
   */
  peerLinks: SnapshotGpuPeerLink[];

  /**
   * Changes on daemon restart or any inventory/class change. Reservations must
   * revalidate this generation and the selected devices before restore.
   *
   * @generated from field: string inventory_generation = 8;
   */
  inventoryGeneration: string;

  /**
   * @generated from field: repeated chalk.container.v1.SnapshotGpuBackendCapability gpu_backends = 9;
   */
  gpuBackends: SnapshotGpuBackendCapability[];
};

/**
 * Describes the message chalk.container.v1.SnapshotHostCapabilities.
 * Use `create(SnapshotHostCapabilitiesSchema)` to create a new message.
 */
export const SnapshotHostCapabilitiesSchema: GenMessage<SnapshotHostCapabilities> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 7);

/**
 * @generated from message chalk.container.v1.SnapshotGpuBackendCapability
 */
export type SnapshotGpuBackendCapability = Message<"chalk.container.v1.SnapshotGpuBackendCapability"> & {
  /**
   * @generated from field: chalk.container.v1.SnapshotGpuBackend backend = 1;
   */
  backend: SnapshotGpuBackend;

  /**
   * @generated from field: uint32 version = 2;
   */
  version: number;

  /**
   * Presence of hardware/tooling alone does not imply validated restore support.
   *
   * @generated from field: bool capture = 3;
   */
  capture: boolean;

  /**
   * @generated from field: bool restore = 4;
   */
  restore: boolean;

  /**
   * @generated from field: bool equivalent_device_restore = 5;
   */
  equivalentDeviceRestore: boolean;

  /**
   * @generated from field: bool multi_gpu = 6;
   */
  multiGpu: boolean;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuBackendCapability.
 * Use `create(SnapshotGpuBackendCapabilitySchema)` to create a new message.
 */
export const SnapshotGpuBackendCapabilitySchema: GenMessage<SnapshotGpuBackendCapability> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 8);

/**
 * @generated from message chalk.container.v1.SnapshotGpuStackProfile
 */
export type SnapshotGpuStackProfile = Message<"chalk.container.v1.SnapshotGpuStackProfile"> & {
  /**
   * @generated from field: string compatibility_class = 1;
   */
  compatibilityClass: string;

  /**
   * Actual host driver and effective nvproxy ABI can differ; preserve both.
   *
   * @generated from field: string kernel_driver_version = 2;
   */
  kernelDriverVersion: string;

  /**
   * @generated from field: string kernel_driver_build = 3;
   */
  kernelDriverBuild: string;

  /**
   * @generated from field: string kernel_driver_variant = 4;
   */
  kernelDriverVariant: string;

  /**
   * @generated from field: string nvproxy_abi = 5;
   */
  nvproxyAbi: string;

  /**
   * OCI mounts host libraries, which are not identified by the base image digest.
   *
   * @generated from field: repeated chalk.container.v1.SnapshotDriverLibrary driver_libraries = 6;
   */
  driverLibraries: SnapshotDriverLibrary[];

  /**
   * @generated from field: string cuda_checkpoint_sha256 = 7;
   */
  cudaCheckpointSha256: string;

  /**
   * @generated from field: string cuda_checkpoint_version = 8;
   */
  cudaCheckpointVersion: string;

  /**
   * @generated from field: string cuda_checkpoint_path = 9;
   */
  cudaCheckpointPath: string;

  /**
   * @generated from field: bool cuda_checkpoint_sequential = 10;
   */
  cudaCheckpointSequential: boolean;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuStackProfile.
 * Use `create(SnapshotGpuStackProfileSchema)` to create a new message.
 */
export const SnapshotGpuStackProfileSchema: GenMessage<SnapshotGpuStackProfile> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 9);

/**
 * @generated from message chalk.container.v1.SnapshotDriverLibrary
 */
export type SnapshotDriverLibrary = Message<"chalk.container.v1.SnapshotDriverLibrary"> & {
  /**
   * @generated from field: string container_path = 1;
   */
  containerPath: string;

  /**
   * @generated from field: string sha256 = 2;
   */
  sha256: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotDriverLibrary.
 * Use `create(SnapshotDriverLibrarySchema)` to create a new message.
 */
export const SnapshotDriverLibrarySchema: GenMessage<SnapshotDriverLibrary> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 10);

/**
 * @generated from message chalk.container.v1.SnapshotGpuHardwareProfile
 */
export type SnapshotGpuHardwareProfile = Message<"chalk.container.v1.SnapshotGpuHardwareProfile"> & {
  /**
   * @generated from field: string compatibility_class = 1;
   */
  compatibilityClass: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * @generated from field: uint32 pci_vendor_id = 4;
   */
  pciVendorId: number;

  /**
   * @generated from field: uint32 pci_device_id = 5;
   */
  pciDeviceId: number;

  /**
   * @generated from field: uint32 pci_subsystem_vendor_id = 6;
   */
  pciSubsystemVendorId: number;

  /**
   * @generated from field: uint32 pci_subsystem_device_id = 7;
   */
  pciSubsystemDeviceId: number;

  /**
   * @generated from field: uint64 total_memory_bytes = 8;
   */
  totalMemoryBytes: bigint;

  /**
   * @generated from field: uint32 compute_capability_major = 9;
   */
  computeCapabilityMajor: number;

  /**
   * @generated from field: uint32 compute_capability_minor = 10;
   */
  computeCapabilityMinor: number;

  /**
   * First supported configurations use exclusive whole GPUs. MIG is deferred.
   *
   * @generated from field: string device_mode = 11;
   */
  deviceMode: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuHardwareProfile.
 * Use `create(SnapshotGpuHardwareProfileSchema)` to create a new message.
 */
export const SnapshotGpuHardwareProfileSchema: GenMessage<SnapshotGpuHardwareProfile> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 11);

/**
 * In a snapshot these are source bindings; in a host report they are available
 * devices. Ordinals scope peer-link references to the enclosing device list.
 *
 * @generated from message chalk.container.v1.SnapshotGpuDevice
 */
export type SnapshotGpuDevice = Message<"chalk.container.v1.SnapshotGpuDevice"> & {
  /**
   * @generated from field: uint32 logical_ordinal = 1;
   */
  logicalOrdinal: number;

  /**
   * @generated from field: chalk.container.v1.SnapshotGpuHardwareProfile hardware = 2;
   */
  hardware?: SnapshotGpuHardwareProfile;

  /**
   * @generated from field: string uuid = 3;
   */
  uuid: string;

  /**
   * @generated from field: uint32 minor = 4;
   */
  minor: number;

  /**
   * @generated from field: string pci_bus_address = 5;
   */
  pciBusAddress: string;

  /**
   * @generated from field: uint32 nvidia_gpu_id = 6;
   */
  nvidiaGpuId: number;

  /**
   * @generated from field: uint32 device_instance = 7;
   */
  deviceInstance: number;

  /**
   * @generated from field: uint32 subdevice_instance = 8;
   */
  subdeviceInstance: number;
};

/**
 * Describes the message chalk.container.v1.SnapshotGpuDevice.
 * Use `create(SnapshotGpuDeviceSchema)` to create a new message.
 */
export const SnapshotGpuDeviceSchema: GenMessage<SnapshotGpuDevice> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_snapshot_compatibility, 12);

/**
 * @generated from enum chalk.container.v1.SnapshotGpuBackend
 */
export enum SnapshotGpuBackend {
  /**
   * @generated from enum value: SNAPSHOT_GPU_BACKEND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SNAPSHOT_GPU_BACKEND_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: SNAPSHOT_GPU_BACKEND_NVIDIA_CUDA = 2;
   */
  NVIDIA_CUDA = 2,
}

/**
 * Describes the enum chalk.container.v1.SnapshotGpuBackend.
 */
export const SnapshotGpuBackendSchema: GenEnum<SnapshotGpuBackend> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_snapshot_compatibility, 0);

